import Drawer from 'records/Drawer';

import {
  DRAWERS_TOGGLE_DRAWER,
  DRAWERS_RESET_STATE,
} from 'actions/drawers';

const initialState = new Drawer();

const actionsMap = {
  [DRAWERS_TOGGLE_DRAWER]: (state, action) => {
    const newState = state.toggleDrawer(action.drawerName);
    return newState;
  },
  [DRAWERS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function drawers(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
